var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletTt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.5 60C119.5 92.8609 92.8609 119.5 60 119.5C27.1391 119.5 0.5 92.8609 0.5 60C0.5 27.1391 27.1391 0.5 60 0.5C92.8609 0.5 119.5 27.1391 119.5 60Z",
    fill: "white",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2089_9394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1592 57.6954C38.0003 57.947 37.9119 58.2366 37.9032 58.534C37.8946 58.8314 37.9659 59.1257 38.1098 59.3861C38.2536 59.6465 38.4648 59.8635 38.7212 60.0145C38.9776 60.1654 39.2698 60.2448 39.5674 60.2442H58.5638C58.706 60.2434 58.8458 60.2808 58.9686 60.3525C59.0913 60.4243 59.1925 60.5277 59.2616 60.652C59.3307 60.7763 59.3652 60.9168 59.3613 61.059C59.3574 61.2011 59.3155 61.3396 59.2397 61.4599L40.5953 91.29C40.5484 91.3664 40.4867 91.4327 40.4137 91.4849C40.3408 91.5371 40.2581 91.5741 40.1706 91.5938C40.083 91.6135 39.9925 91.6155 39.9042 91.5996C39.8159 91.5836 39.7317 91.5502 39.6566 91.5012C32.9389 87.1677 27.7817 80.8011 24.9372 73.3301C22.0927 65.8592 21.7098 57.6748 23.8444 49.9709C25.9789 42.267 30.5192 35.4467 36.803 30.505C43.0867 25.5632 50.7851 22.7585 58.775 22.5001C58.8938 22.4978 59.011 22.5276 59.1142 22.5866C59.2174 22.6455 59.3026 22.7313 59.3609 22.8348C59.4191 22.9384 59.4483 23.0558 59.4451 23.1746C59.442 23.2933 59.4067 23.409 59.343 23.5093L38.1592 57.6954ZM81.0009 28.9074C80.927 28.856 80.8433 28.8203 80.755 28.8026C80.6667 28.7849 80.5757 28.7856 80.4877 28.8045C80.3997 28.8234 80.3165 28.8602 80.2433 28.9127C80.1701 28.9651 80.1084 29.032 80.0621 29.1092L61.7041 58.5027C61.6289 58.6231 61.5873 58.7614 61.5834 58.9032C61.5794 59.0451 61.6134 59.1854 61.6818 59.3098C61.7502 59.4341 61.8505 59.538 61.9724 59.6106C62.0943 59.6833 62.2334 59.7221 62.3753 59.7232H81.3905C81.6873 59.7231 81.9787 59.8026 82.2344 59.9533C82.4901 60.104 82.7008 60.3204 82.8445 60.5801C82.9883 60.8398 83.0598 61.1333 83.0518 61.43C83.0437 61.7267 82.9563 62.0158 82.7987 62.2673L61.3051 96.6364C61.2528 96.7173 61.224 96.8112 61.2219 96.9075C61.2198 97.0038 61.2444 97.0988 61.293 97.182C61.3417 97.2652 61.4124 97.3332 61.4974 97.3786C61.5824 97.424 61.6783 97.4449 61.7745 97.4391C69.645 97.0716 77.1998 94.2345 83.3667 89.3303C89.5335 84.4262 93.9989 77.7042 96.1291 70.1185C98.2594 62.5328 97.9461 54.4689 95.2339 47.0713C92.5217 39.6738 87.5483 33.3184 81.0197 28.9074H81.0009Z",
    fill: "url(#paint0_linear_2089_9394)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2089_9394",
    x1: 54.8744,
    y1: 37.9667,
    x2: 68.0503,
    y2: 94.5757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#00FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00F8D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00E4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00C3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0096D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#005CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0016D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0000D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2089_9394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 74.9389,
    fill: "white",
    transform: "translate(22.5 22.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletTt);
export default __webpack_public_path__ + "static/media/wallet_tt.47bb08b649182ff83ba8c244aa3acc00.svg";
export { ForwardRef as ReactComponent };